// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
export type OrganizationSetupFragment = {
  __typename?: "Organization";
  id: string;
  name: string;
  onboardingProgress: {
    __typename?: "OrganizationOnboardingProgress";
    id: string;
    lastIntegratedServer?: {
      __typename?: "Server";
      id: string;
      humanId: string;
    } | null;
  };
};

export const OrganizationSetupFragmentDoc = gql`
  fragment OrganizationSetup on Organization {
    id
    name
    onboardingProgress {
      id
      lastIntegratedServer {
        id
        humanId
      }
    }
  }
`;
